import { render } from "./LoadingXD.vue?vue&type=template&id=46ba2f08&scoped=true"
import script from "./LoadingXD.vue?vue&type=script&lang=js"
export * from "./LoadingXD.vue?vue&type=script&lang=js"

import "./LoadingXD.vue?vue&type=style&index=0&id=46ba2f08&scoped=true&lang=css"

import exportComponent from "C:\\Users\\47959\\OneDrive\\Documents\\GitHub\\Poesiparken\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ba2f08"]])

export default __exports__